import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import "../styles/Login.css";
import Footer from "../FooterBn";

const ResetPassword = () => {
  const { token } = useParams(); // Token from URL
  const navigate = useNavigate();

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (newPassword !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    try {
      setLoading(true);
      const response = await axios.post(
        "https://server.goatteachers.com/api/auth/reset-password",
        {
          token,
          password: newPassword,
        },
      );

      setSuccess(" Your password has been successfully reset!");
      setTimeout(() => {
        navigate("/login");
      }, 2000);
    } catch (err) {
      setError(
        err.response?.data?.message ||
          "❌ Failed to reset password. Try again.",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <section className="login-section">
        <div className="login-container">
          <div className="login-box">
            <h2 className="iqWTbl">Create New Password</h2>
            <p className="authquote">
              Set a strong new password for your account. Make sure it’s
              something you can remember.
            </p>

            {success && <p className="success-message">{success}</p>}
            {error && <p className="error-message">{error}</p>}

            <form onSubmit={handleSubmit} className="login-form">
              <div className="input-group">
                <label htmlFor="new-password">New Password</label>
                <input
                  type="password"
                  id="new-password"
                  className="input-field"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  required
                />
              </div>

              <div className="input-group">
                <label htmlFor="confirm-password">Confirm Password</label>
                <input
                  type="password"
                  id="confirm-password"
                  className="input-field"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                />
              </div>

              <button
                type="submit"
                className="login-btn"
                style={{ marginTop: "20px" }}
                disabled={loading}
              >
                {loading ? "Resetting..." : "Save New Password"}
              </button>
            </form>

            <p className="back-to-login">
              <a
                onClick={() => navigate("/login")}
                style={{ cursor: "pointer" }}
              >
                ← Back to Login
              </a>
            </p>
          </div>
        </div>
        <Footer />
      </section>
    </>
  );
};

export default ResetPassword;
